import { isCuid } from "@paralleldrive/cuid2"
import { z } from "zod"

export const wallPathParams = z.object({
  wallId: z.string().refine(isCuid),
  wallNumber: z.string().refine((val) => !isNaN(Number(val))),
  sessionId: z.string().refine(isCuid),
})

export const photoStepSearchSchema = z.object({
  // Used to display photo in photos overview in each step
  currentPhotoId: z.string().optional(),
})

export const amenityFormSearchSchema = z.object({
  viewMode: z.literal("add").optional(),
})
